import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { isNullOrUndefined } from 'util';

interface ISearchableSelectModalProps {
    title: string,
    text?: string,
    options: string[],
    onSelect: (value: string) => void,
    searchable?: boolean,
    currentSelection?: string,
}

interface ISearchableSelectModalState {
    filteredOptions: string[],
    search?: string,
    open: boolean,
    chosen?: string,
}

export default class SearchableSelectModal extends React.Component<ISearchableSelectModalProps, ISearchableSelectModalState>{
    constructor(props) {
        super(props);
        this.state = {
            filteredOptions: this.props.options,
            search: undefined,
            open: false,
            chosen: this.props.currentSelection,
        };
    }

    public render() {
        const optionDisplay: any[] = [];
        if (this.state.filteredOptions.length > 0) {
            this.state.filteredOptions.map((option, index) => {
                optionDisplay.push(<ModalOption key={option + index} onSelect={this.HandleSelect} value={option} />);
            });
        }

        let label = this.props.title;
        if (this.props.searchable === true) {
            if (isNullOrUndefined(this.state.chosen) || this.state.chosen=='') {
                label = ' is: Any';
            }
            else {
                label = ' is: ' + this.state.chosen;
            }
        }
        if (this.props.currentSelection) {
            label = 'is: ' + this.props.currentSelection;
        }
        else if (this.props.options[0] === 'SUN') {
            label = ' Week Beginning:  ' + this.state.chosen;
        }

        return (
            <Grid>
                <Chip
                    style={{minWidth:'80px'}}
                    label={label}
                    clickable
                    onClick={this.Open}
                />
                <Dialog
                    open={this.state.open}
                    onClose={this.Close}
                    maxWidth="lg" fullWidth>
                    <DialogTitle>
                        {this.props.title}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                            {this.props.text &&
                                <Grid> 
                                    <DialogContentText> {this.props.text} </DialogContentText>
                                </Grid>
                            }
                            {this.props.searchable === true &&
                                <Grid>
                                    <TextField fullWidth placeholder={"Search..."} onChange={this.Search} />
                                </Grid>
                            }
                            <Grid>
                                <Grid container justifyContent={"center"} alignContent={"center"} spacing={1}>
                                    {optionDisplay}
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Close} color="primary">Cancel</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        );
    }

    public Search = (e) => {
        const value: string = e.target.value;
        this.setState({
            search: value
        });
        if (value !== "") {
            const filteredOptions = this.props.options.filter(option => option.toLowerCase().includes(value.toLowerCase()));
            this.setState({
                filteredOptions: filteredOptions
            });
        } else {
            this.setState({
                filteredOptions: this.props.options
            });
        }
    }
    public HandleSelect = (value: string) => {
        this.Close();
        this.setState({ chosen: value });
        this.props.onSelect(value);
    }
    public Open = () => {
        this.setState({
            open: true,
            filteredOptions: this.props.options,
            search: undefined
        });
    }
    public Close = () => {
        this.setState({ open: false, });
    }
}

interface IModalOptionProps {
    label?: string,
    value: string,
    onSelect: (value: string) => void
}
class ModalOption extends React.Component<IModalOptionProps, any>{
    constructor(props) {
        super(props);
    }

    public render() {
        const text = this.props.label != null ? this.props.label : this.props.value;
        return (
            <Grid>
                <Button fullWidth onClick={this.HandleClick}>{text}</Button>
            </Grid>
        );
    }

    public HandleClick = () => {
        this.props.onSelect(this.props.value);
    }
}